import {Component, ElementRef, HostListener, Input, OnDestroy, ViewChild} from '@angular/core';
import {Melody} from "../../model/melody";
import {constants} from "../../constants";

declare var $: any;

@Component({
  selector: 'app-hit-melodies',
  templateUrl: './hit-melodies.component.html',
  styleUrls: ['./hit-melodies.component.css']
})
export class HitMelodiesComponent implements OnDestroy {
  @Input() melodies: ReadonlyArray<Melody>;
  @Input() showSubtitle: boolean;

  private _hitsSlider: ElementRef;

  private sliderInit: boolean;

  constructor() {
    this.sliderInit = false;
  }

  @ViewChild("hitsSlider") set hitsSlider(value: ElementRef) {
    this.removeSlider();

    this._hitsSlider = value;

    if (window.innerWidth > constants.desktopScreenBreakpoint) {
      this.initHitsSlider();
    }
  }

  @HostListener('window:resize')
  resize(): void {
    if (this._hitsSlider) {
      if (window.innerWidth > constants.desktopScreenBreakpoint && !this.sliderInit) {
        this.initHitsSlider();
      }

      if (window.innerWidth <= constants.desktopScreenBreakpoint && this.sliderInit) {
        this.removeSlider()
      }
    }
  }

  initHitsSlider(): void {
    if (!this.sliderInit && this._hitsSlider) {
      $(this._hitsSlider.nativeElement).slick({
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: false,
        variableWidth: true,
      });
      this.sliderInit = true;
    }
  }

  removeSlider(): void {
    if (this.sliderInit && this._hitsSlider) {
      $(this._hitsSlider.nativeElement).slick("unslick");
      this.sliderInit = false;
    }
  }

  ngOnDestroy(): void {
    this.removeSlider()
  }
}
